const WardsUnderConstruction = () => (
  <div style={{ textAlign: 'center', padding: 40, alignItems: 'center' }}>
    <h1>🚧 This is currently under construction or urls seems to be missing 🚧 </h1>
  </div>
);

export default WardsUnderConstruction;
